import _ from 'lodash';
import { useCallback, useRef, useState } from 'react';
import { useSearchParam } from 'react-use';
import { loadScript } from '../utils/helper';
import { extendMarkerClustering } from './MarkerClustering';

export function useNaverMap(mapOptions?: {
  onMapClick?: (...args: any[]) => any;
  [key: string]: any;
  onZoomChanged?: (...args: any[]) => any;
  onDragend?: (...args: any[]) => any;
}) {
  const ref = useRef();
  const [map, setMap] = useState();
  const { lat, lng, zoom } = useMapSearchParams();
  const callbackRef = useCallback(div => {
    if (div) {
      ref.current = div;
      initNaverMap();
    }
    async function initNaverMap() {
      await loadScript(
        `//oapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${process.env.REACT_APP_NAVER_APP_KEY}&submodules=geocoder`,
        'naver-map-v3',
      );
      extendMarkerClustering();

      const options = {
        center: new window.naver.maps.LatLng(35.1701583, 126.9073814),
        zoom: 10,
        // zoomControl: true,
        ..._.omit(mapOptions, ['onMapClick']),
      };
      if (lat && lng) {
        options.center = new window.naver.maps.LatLng(lat, lng);
      }
      if (zoom) {
        options.zoom = +zoom;
      }

      const map = new window.naver.maps.Map(div, options);
      const onMapClick = mapOptions?.onMapClick;
      if (typeof onMapClick === 'function') {
        new window.naver.maps.Event.addListener(map, 'click', e =>
          onMapClick(e, map),
        );
      }

      const onZoomChanged = mapOptions?.onZoomChanged;
      if (typeof onZoomChanged === 'function') {
        new window.naver.maps.Event.addListener(map, 'zoom_changed', e =>
          onZoomChanged(e, map),
        );
      }
      const onDragend = mapOptions?.onDragend;
      if (typeof onDragend === 'function') {
        new window.naver.maps.Event.addListener(map, 'dragend', e =>
          onDragend(e, map),
        );
      }

      setMap(map);
    }

    // eslint-disable-next-line
  }, []);

  return { ref, setRef: callbackRef, map };
}

export function useMapSearchParams() {
  const lat = useSearchParam('lat');
  const lng = useSearchParam('lng');
  const zoom = useSearchParam('zoom');
  const jibunAddress = useSearchParam('jibunAddress');
  const roadAddress = useSearchParam('roadAddress');

  return { lat, lng, zoom, jibunAddress, roadAddress };
}
